import { useSubscription } from './use-subscription';
import { useState, useRef } from 'react';
import { useObservableCallback } from './use-observable-callback';
export function useObservableState(...args) {
    const stateRef = useRef(args[1]);
    const setStateRef = useRef();
    let callback;
    let states$;
    if (typeof args[0] === 'function') {
        ;
        [callback, states$] = useObservableCallback(args[0]);
    }
    else {
        states$ = args[0];
    }
    useSubscription(states$, state => {
        // assign value before setState
        stateRef.current = state;
        if (setStateRef.current) {
            setStateRef.current(state);
        }
    });
    // Putting useState after subcription will skip re-rendering
    // of all sync emitted values from the Observable.
    setStateRef.current = useState(stateRef.current)[1];
    return callback ? [stateRef.current, callback] : stateRef.current;
}
//# sourceMappingURL=use-observable-state.js.map